import React, { useEffect } from 'react';
import { Space, Tooltip } from 'antd';
import { Tag } from '../ui';

/**
 * Componente para exibir múltiplos projetos de forma compacta
 * @param {Array} projects - Lista de projetos
 * @param {number} maxVisible - Número máximo de projetos visíveis (padrão: 2)
 * @param {string} size - Tamanho dos tags ('small', 'default')
 * @param {function} getProjectName - Função para extrair o nome do projeto (padrão: p => p.name)
 */
const ProjectsDisplay = ({ 
  projects = [], 
  maxVisible = 2, 
  size = 'small',
  getProjectName = (p) => p.name 
}) => {

  useEffect(() => {
  }, [projects]);
  if (!projects || projects.length === 0) {
    return <span style={{ color: '#8c8c8c', fontSize: '12px' }}>Nenhum projeto</span>;
  }


  // Se tem apenas um projeto, mostra ele simples
  if (projects.length === 1) {
    return (
      <Tag color="blue" size={size}>
        {getProjectName(projects[0])}
      </Tag>
    );
  }

  // Se tem 2 ou menos projetos e maxVisible >= 2, mostra todos
  if (projects.length <= maxVisible) {
    return (
      <Space size={4} wrap>
        {projects.map((project, index) => (
          <Tag key={index} color="blue" size={size}>
            {getProjectName(project)}
          </Tag>
        ))}
      </Space>
    );
  }

  // Se tem mais projetos que o máximo visível
  const visibleProjects = projects.slice(0, maxVisible);
  const hiddenCount = projects.length - maxVisible;
  const hiddenProjects = projects.slice(maxVisible);


  
  return (
    <Space size={4} wrap>
      {/* Projetos visíveis */}
      {visibleProjects.map((project, index) => (
        <Tag key={index} color="blue" size={size}>
          {getProjectName(project)}
        </Tag>
      ))}
      
      {/* Indicador de projetos ocultos com tooltip */}
      <Tooltip
        title={
          <div>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>
              Outros projetos ({hiddenCount}):
            </div>
            {hiddenProjects.map((project, index) => (
              <div key={index} style={{ marginBottom: 4 }}>
                • {getProjectName(project)}
              </div>
            ))}
          </div>
        }
        placement="top"
      >
        <Tag 
          color="default" 
          size={size}
          style={{ 
            cursor: 'pointer',
            borderStyle: 'dashed',
            color: '#8c8c8c'
          }}
        >
          +{hiddenCount} projeto{hiddenCount > 1 ? 's' : ''}
        </Tag>
      </Tooltip>
    </Space>
  );
};

export default ProjectsDisplay; 